'use strict'

import FormData from 'form-data'

export const config = {
  lang: {
    apiCanceled: 'Request Canceled'
  }
}

/**
 * 共通
 * @type object
 */
export default {
  /**
   * API用Formデータ
   * @param params
   * @returns {*}
   */
  getFormData (params) {
    let form = new FormData()
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        key = key + ''
        form.append(key, params[key])
      }
    }
    return form
  },

  isApiCanceled (error) {
    return error.message === config.lang.apiCanceled
  }
}



// WEBPACK FOOTER //
// ./src/repositories/utils/Common.js